import { css, DefaultTheme } from 'styled-components';

export type MarginSpacing = {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
};

const MarginsHandler = ({ $margin }: { theme: DefaultTheme; $margin?: MarginSpacing }) =>
  $margin &&
  css`
    margin-top: ${({ theme }) => $margin.top && `${theme.spacing($margin.top)}`};
    margin-left: ${({ theme }) => $margin.left && `${theme.spacing($margin.left)}`};
    margin-right: ${({ theme }) => $margin.right && `${theme.spacing($margin.right)}`};
    margin-bottom: ${({ theme }) => $margin.bottom && `${theme.spacing($margin.bottom)}`};
  `;
export { MarginsHandler };
